import { Box, Stack, TextInput, Text, Textarea, useMantineTheme, Checkbox, type StackProps } from '@mantine/core';

import { type UseFormReturnType } from '@mantine/form';

import { WIN_THEMES_CONTEXT_HELPER_TEXT, WIN_THEMES_CONTEXT_TEXT } from '../../utils/constants';
import Dropzone from '../Dropzone';
import { type FileWithMetadata } from './UploadResources/UploadResources';

interface FormValues {
  files: File[]
  proposalName: string
  additionalContext: string
}

type Props = {
  form: UseFormReturnType<FormValues>
  setSkipFileUpload?: (skip: boolean) => void
  skipFileUpload?: boolean
} & StackProps;

const InitializeProposalForm: React.FC<Props> = (props: Props) => {
  const { form, setSkipFileUpload, skipFileUpload, ...stackProps } = props;
  const { colors } = useMantineTheme();
  const handleSetFilesOnForm = (files: FileWithMetadata[]) => {
    const filesToAdd = files.map((file) => file.fileObject);
    form.setFieldValue('files', filesToAdd);
  };

  const checkbox = setSkipFileUpload !== undefined && form.values.files.length === 0 && (
    <Checkbox
      onChange={() => { setSkipFileUpload(!(skipFileUpload ?? false)); }}
      label='Skip file upload (for Microsoft Add-In users)'
    />
  );
  return (
    <Stack {...stackProps}>
      <TextInput
        placeholder='Your proposal name'
        label='Proposal name'
        styles={{ input: { height: '48px' } }}
        {...form.getInputProps('proposalName')}
        required
      />
      <Dropzone
        disabled={skipFileUpload}
        files={form.values.files.map((file) => { return { fileObject: file }; })}
        setFiles={handleSetFilesOnForm}
        instructionText='Click or drag and drop to upload your opportunity file(s)'
      />
      {checkbox}
      <Box>
        <Box>
          <Text fz='sm' fw={500} pb={12}> {WIN_THEMES_CONTEXT_TEXT} </Text>
          <Textarea
            placeholder={WIN_THEMES_CONTEXT_HELPER_TEXT}
            {...form.getInputProps('additionalContext')}
            styles={{
              input: {
                height: '130px',
                border: 'none',
                backgroundColor: colors.lightPurple[0]
              }
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
};

export default InitializeProposalForm;
